
import GridData from '@/sag-core/base/GridDataBase.js'
export default new GridData(
    {
        name: 'HGridData',
        columns: [
            // label 欄位顯示名稱
            // field 資料表欄位名稱
            {
                label: '產品品號',
                field: 'ProdNo'
            },
            {
                label: '產品數量', 
                field: 'ProdQty' 
            },
            {
                label: '產品單位',
                field: 'ProdUnit',
                type: 'decimal'
            },
            {
                label: '預交日期',
                field: 'CoursePlace',
                type: 'date'
            }
        ],
        columnsConfig: {
            tdClass: 'align-middle',
            filterOptions: {
                enabled: false,
                placeholder: `Search`
            }
        }
    }
)